module.exports = __webpack_public_path__ + "media/images/reply-21ce91ec463dd09685b3e9abdaff738d.svg";